import React, { Component } from 'react';
import { Form, Input, Label, SubLabel, Button } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Tetanus extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Tetanus">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Tetanus__Form"
        >
          <h1>{translate('fiche.tetanus.title')}</h1>

          <Label text={translate('fiche.tetanus.latest_tetanus')} />
          <SubLabel text={translate('fiche.tetanus.latest_tetanus_sub')} />
          <Input
            name="latest_tetanus"
            rules={['required', 'date']}
            defaultValue={data.latest_tetanus}
            placeholder="DD/MM/YYYY"
          />

          <Label text={translate('fiche.tetanus.serotherapy')} />
          <Input name="serotherapie" defaultValue={data.serotherapie} />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Tetanus);
